import React from 'react';
import { Card } from './Card';
import { cn } from '../../utils/cn';

export interface StatCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  icon: React.ElementType;
  accent?: 'primary' | 'success' | 'warning' | 'danger';
  className?: string;
}

const ACCENT_CLASSES: Record<NonNullable<StatCardProps['accent']>, string> = {
  primary: 'bg-primary/10 text-primary',
  success: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  warning: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  danger: 'bg-rose-500/10 text-rose-600 dark:text-rose-400',
};

/**
 * Compact stat tile - 40x40 icon-in-a-tinted-box, replaces the heavier
 * border-l-4 + p-6 tiles previously duplicated on Recommendations/Anomalies.
 */
export const StatCard: React.FC<StatCardProps> = ({ label, value, subtext, icon: Icon, accent = 'primary', className }) => {
  return (
    <Card className={cn('flex items-start gap-3 p-4', className)}>
      <div className={cn('flex h-10 w-10 shrink-0 items-center justify-center rounded-lg', ACCENT_CLASSES[accent])}>
        <Icon className="h-5 w-5" />
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-medium text-muted-foreground">{label}</span>
        <span className="text-xl font-semibold tracking-tight text-foreground">{value}</span>
        {subtext && <span className="text-2xs text-muted-foreground">{subtext}</span>}
      </div>
    </Card>
  );
};
